import ChatIcon from '@mui/icons-material/Chat';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import { TikTokIcon } from '@components/TikTokIcon';
import LanguageIcon from '@mui/icons-material/Language';
import TelegramIcon from '@mui/icons-material/Telegram';
import SmsIcon from '@mui/icons-material/Sms';

/// O Chatwoot identifica o canal por string longa ("Channel::Whatsapp"); aqui vira algo legível.
const CHANNEL_IDENTITY: Record<string, { label: string; Icon: typeof ChatIcon; color: string }> = {
    whatsapp: { label: 'WhatsApp', Icon: WhatsAppIcon, color: '#1F9D55' },
    instagram: { label: 'Instagram', Icon: InstagramIcon, color: '#C13584' },
    tiktok: { label: 'TikTok', Icon: TikTokIcon, color: '#111827' },
    email: { label: 'E-mail', Icon: EmailIcon, color: '#2563A8' },
    webwidget: { label: 'Site', Icon: LanguageIcon, color: '#6B7280' },
    telegram: { label: 'Telegram', Icon: TelegramIcon, color: '#229ED9' },
    sms: { label: 'SMS', Icon: SmsIcon, color: '#7C3AED' },
};

export function resolve(channel: string) {
    const key = (channel ?? '').toLowerCase();
    const match = Object.keys(CHANNEL_IDENTITY).find((k) => key.includes(k));

    return match
        ? CHANNEL_IDENTITY[match]
        : { label: channel || 'Canal', Icon: ChatIcon, color: '#6B7280' };
}
